// src/theme.ts
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#567A68',
    },
    secondary: {
      main: '#F4951D',
    },
    background: {
      default: '#F5EED1',
      paper: '#FAFAF5',
    },
    text: {
      primary: '#2E4739',
      secondary: '#5A5A5A',
    },
  },
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
  },
    components: {
    MuiButton: {
      styleOverrides: {
        containedSecondary: {
          color: '#fff', // testo bianco
          '&:hover': {
            backgroundColor: '#F4951D', // versione più scura del tuo secondary.main
          },
        },
      },
    },
  },
});
export default theme;
